import React, { useEffect, useState } from 'react';
import { Button, Table } from 'flowbite-react';
import {
  CheckCircleIcon,
  XCircleIcon,
  ArrowPathRoundedSquareIcon,
  ArrowLeftOnRectangleIcon,
  ArrowTopRightOnSquareIcon,
} from '@heroicons/react/24/solid';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

import paymentService from '../../../../services/PaymentService';
import { PaymentModel } from '../../../../models/payment-model';
import { PaymentStatusEnum } from '../../../../enums/payment-status.enum';

export default function Payments() {
  const [payments, setPayments] = useState<PaymentModel[]>();

  useEffect(() => {
    paymentService.getFiltered().then((res) => {
      setPayments(res.data);
    });

    var sub = paymentService.paymentCreated$.subscribe(() => {
      console.log('paymentCreated$ triggered');
      paymentService.getFiltered().then((res) => {
        setPayments(res.data);
      });
    });

    return () => {
      sub.unsubscribe();
    };
  }, []);

  const getStatusIcon = (status: PaymentStatusEnum) => {
    switch (status) {
      case PaymentStatusEnum.Success:
        return <CheckCircleIcon className="w-10 h-10 text-green-600" />;
      case PaymentStatusEnum.Failed:
        return <XCircleIcon className="w-10 h-10 text-red-600" />;
      case PaymentStatusEnum.Created:
        return <ArrowLeftOnRectangleIcon className="w-10 h-10 text-bold text-blue-600" />;
      case PaymentStatusEnum.Processing:
        return <ArrowPathRoundedSquareIcon className="w-10 h-10 text-bold text-blue-600" />;
    }
  };

  const getActionButton = (payment: PaymentModel) => {
    switch (payment.status) {
      case PaymentStatusEnum.Processing:
      case PaymentStatusEnum.Created:
        return (
          <Button
            onClick={() => {
              const newTab = window.open(payment.paymentUrl!, '_blank');
              if (newTab) {
                newTab.focus();
              }
            }}
            className="w-full"
          >
            Pay <ArrowTopRightOnSquareIcon className="h-6 w-6 text-white ml-2" />
          </Button>
        );
      default:
        return <></>;
    }
  };

  return (
    <>
      <h2 className="text-white text-2xl text-bold mb-5 font-bold">Payments</h2>

      <Table className="overflow-x-auto">
        <Table.Head>
          <Table.HeadCell>Status</Table.HeadCell>
          <Table.HeadCell>Id</Table.HeadCell>
          <Table.HeadCell>Created At</Table.HeadCell>
          <Table.HeadCell>Service</Table.HeadCell>
          <Table.HeadCell>Total pay</Table.HeadCell>
          <Table.HeadCell className="w-12">Action</Table.HeadCell>
        </Table.Head>
        <Table.Body className="divide-y">
          {payments?.length ? (
            payments.map((x, index) => (
              <Table.Row key={index} className="bg-white dark:border-gray-700 dark:bg-gray-800">
                <Table.Cell>{getStatusIcon(x.status!)}</Table.Cell>
                <Table.Cell>{x.id}</Table.Cell>
                <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                  {dayjs(x.dateCreated).format('DD/MM/YYYY HH:mm')}
                </Table.Cell>
                <Table.Cell>{x.subscriptionName}</Table.Cell>
                <Table.Cell>${x.amount}</Table.Cell>
                <Table.Cell>{getActionButton(x!)}</Table.Cell>
              </Table.Row>
            ))
          ) : (
            <Table.Row className="bg-white dark:border-gray-700 dark:bg-gray-800">
              <Table.Cell colSpan={6} className="text-center text-gray-500">
                No payments found.
              </Table.Cell>
            </Table.Row>
          )}
        </Table.Body>
      </Table>
    </>
  );
}
